module.exports = __webpack_public_path__ + "static/img/detailImgszj.21a53ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/detailImgszj.jpg
// module id = lWBL
// module chunks = 6